import { Theme } from '@mui/material/styles';
import { alpha } from '@mui/material';

export default function Switch(theme: Theme) {
  return {
    MuiSwitch: {
      styleOverrides: {
        root: {
          width: 48,
          height: 28,
          padding: 0,
        },
        switchBase: {
          padding: 3,
          color: theme.palette.info.main,
          transitionDuration: '200ms',
          '&.Mui-checked': {
            transform: 'translateX(20px)',
            color: theme.palette.accent.contrastText,
            '& + .MuiSwitch-track': {
              backgroundColor: theme.palette.accent.main,
              opacity: 1,
              border: 0,
            },
            '&.Mui-disabled + .MuiSwitch-track': { opacity: 0.3 },
          },
          '&.Mui-focusVisible .MuiSwitch-thumb': {
            boxShadow: `0 0 0 4px ${alpha(theme.palette.accent.main, 0.4)}`,
          },
          '&.Mui-disabled .MuiSwitch-thumb': { opacity: 0.5 },
        },
        thumb: {
          width: 22,
          height: 22,
          boxShadow: 'none',
        },
        track: {
          borderRadius: 14,
          backgroundColor: alpha(theme.palette.primary.main, 0.28),
          opacity: 1,
          transition: theme.transitions.create(['background-color']),
        },
      },
    },
  };
}
